const pvExtrairValorResposta = pResposta => {
  if (pResposta == null) {
    return pResposta;
  }

  if (typeof pResposta === 'object') {
    return pResposta?.valor;
  }

  if (typeof pResposta !== 'string') {
    return pResposta;
  }

  const xResposta = pResposta.trim();

  if (!xResposta) {
    return pResposta;
  }

  try {
    const xRespostaParseada = JSON.parse(xResposta);

    if (xRespostaParseada && typeof xRespostaParseada === 'object') {
      return xRespostaParseada?.valor;
    }

    return xRespostaParseada;
  } catch (_pErro) {
    return pResposta;
  }
};

/**
 * Indica se o valor representa uma resposta preenchida, incluindo zero.
 */
export const temValorResposta = pValor => {
  return !(pValor === null || pValor === undefined || pValor === '');
};

export const normalizarRespostaPayloadParaUpsert = pData => {
  if (!pData || !Object.prototype.hasOwnProperty.call(pData, 'resposta')) {
    return pData;
  }

  const xValorResposta = pvExtrairValorResposta(pData.resposta);

  return {
    ...pData,
    resposta: xValorResposta === true ? '1' : xValorResposta === false ? '0' : String(xValorResposta)
  };
};

export default normalizarRespostaPayloadParaUpsert;
